import ProductOptions from "@/utils/product_options";

export class Pagination {
  currentPage?: number;
  totalPages?: number;
  totalItems?: number;
  itemsPerPage?: boolean;
  pageOptions?: number[];

  public static of(data: any): Pagination {
    const p: Pagination = new Pagination();

    p.currentPage = data?.number ?? 1;
    p.totalPages = data?.totalPages ?? 1;
    p.totalItems = data?.totalElements ?? 0;
    p.itemsPerPage = data?.size ?? 24;
    p.pageOptions = ProductOptions.getProductOptions.itemPerPage;

    return p;
  }
}